import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import backk from './images/backk.png'; 

const Rosap = () => {
  const navigate = useNavigate();
  const [userEmail, setUserEmail] = useState(null);

  const buttonStyle = {
    backgroundColor: '#E11584',
    color: '#fff',
    padding: '10px 20px',
    fontSize: '16px',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    marginTop: '20px',
    width: '150px',
  };

  const containerStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    height: '100vh',
    justifyContent: 'flex-start',
    paddingTop: '50px',
  };

  const headingStyle = {
    color: '#E11584',
    fontSize: '32px',
    fontWeight: 'bold',
    marginBottom: '40px',
  };

  useEffect(() => {
    const email = sessionStorage.getItem('userEmail');
    if (!email) {
      navigate('/signin');
    } else {
      setUserEmail(email);
    }
  }, [navigate]);

  const handleSetUpClick = () => {
    navigate('/SetUps');
  };

  const handleStartUpClick = () => {
    navigate('/StartUps');
  };

  const handleReportClick = () => {
    navigate('/Detail'); // Add your report route here
  };

  const handleBackClick = () => {
    navigate(-1); // Navigate to the previous page
  };

  const handleViewEditClick = () => {
    // Add your navigation or function for View/Edit
    navigate('/ViewsEdits');
  };

  const handleDeleteClick = () => {
    navigate('/Deletes');
  };

  return (
    <div style={{ 
      background: 'linear-gradient(to bottom, #fff7ad, #ffa9f9)', 
      minHeight: '100vh', 
      padding: '20px', 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center', 
      justifyContent: 'center',
      textAlign: 'center' 
    }}>
      <div style={containerStyle}>
        <h1 style={headingStyle}>Rosa P Main Screen</h1>
        
        {userEmail && (
          <p 
            style={{ 
              color: '#E11584', 
              fontSize: '20px', 
              textAlign: 'center', 
              marginBottom: '20px' 
            }}
          >
            Signed in as: {userEmail}
          </p>
        )}

        <button style={buttonStyle} onClick={handleSetUpClick}>Set Up</button>
        <button style={buttonStyle} onClick={handleStartUpClick}>Start Up</button>
        <button style={buttonStyle} onClick={handleReportClick}>Report</button>
        
        {/* New buttons for View/Edit and Delete */}
        <button style={buttonStyle} onClick={handleViewEditClick}>View/Edit</button>
        <button style={buttonStyle} onClick={handleDeleteClick}>Delete</button>

        <br />
        <img 
          src={backk} 
          width="30" 
          height="40" 
          alt="Back" 
          style={{ cursor: 'pointer', marginTop: '20px' }} 
          onClick={handleBackClick} 
        />
      </div>
    </div>
  );
};

export default Rosap;
